export default defineNuxtRouteMiddleware((to) => {
  const tenant = to.params.tenant

  if (tenant === 'exchange' && /^\/exchange\/.+/.test(to.path)) {
    const newPath = to.fullPath.replace(/^\/exchange\//, '/')
    return navigateTo(newPath, { redirectCode: 301 })
  }
})
